import { render, staticRenderFns } from "./processPage.vue?vue&type=template&id=cf786560&scoped=true&"
import script from "./processPage.vue?vue&type=script&lang=js&"
export * from "./processPage.vue?vue&type=script&lang=js&"
import style0 from "./processPage.vue?vue&type=style&index=0&id=cf786560&lang=less&scoped=true&"
import style1 from "./processPage.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf786560",
  null
  
)

export default component.exports